import { TestsBySectionPage } from "./TestsBySectionPage";

const TestsBySection = () => {
	return <TestsBySectionPage />;
};
export default TestsBySection;
